import {
  readCurrentTenantUuid,
  TENANT_CONTEXT_CHANGED_EVENT,
} from '@/adapters/tenantStorage';

let tenantScopeVersion = 0;

if (typeof window !== 'undefined') {
  window.addEventListener(TENANT_CONTEXT_CHANGED_EVENT, () => {
    tenantScopeVersion += 1;
  });
}

export class StaleTenantRequestError extends Error {
  constructor() {
    super('租户上下文已变化，请重新加载数据');
    this.name = 'StaleTenantRequestError';
  }
}

export const runInCurrentTenantScope = async <T>(
  run: () => Promise<T>,
): Promise<T> => {
  const version = tenantScopeVersion;
  const tenantUuid = readCurrentTenantUuid();
  if (!tenantUuid) {
    throw new Error('当前租户不可用');
  }

  const result = await run();

  if (
    version !== tenantScopeVersion ||
    tenantUuid !== readCurrentTenantUuid()
  ) {
    throw new StaleTenantRequestError();
  }

  return result;
};
